import {AdminApi} from "./AdminApi";
import { Notification } from "../models/Notification";
import {ViewedNotification} from "../models/ViewedNotifications";

const AdminBrandsApi = AdminApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationsForUser: builder.query<Notification[], {brandSlug: string, locationSlug: string}>({
      query: ({brandSlug, locationSlug}) => {
        return {
          url: `notifications/${brandSlug}/${locationSlug}`,
          method: "GET"
        };
      },
    }),
    markNotificationAsViewed: builder.mutation<undefined, {notificationId: number}>({
      query: ({notificationId}) => {
        return {
          url: `notifications/${notificationId}`,
          method: "POST"
        };
      },
    }),
    markNotificationsAsViewed: builder.mutation<undefined, {notifications: ViewedNotification}>({
      query: ({notifications}) => {
        return {
          url: "notifications",
          method: "POST",
          body: notifications
        };
      },
    })
  }),
});

export const {
  useLazyGetNotificationsForUserQuery,
  useMarkNotificationAsViewedMutation,
  useMarkNotificationsAsViewedMutation
} = AdminBrandsApi;
